
                    import wasm from "../../dist/pkg/perspective_bg.wasm";
                    export default Promise.resolve(wasm);
                